<template>
  <LayoutGradient :title="pageTitle" icon="fa-file-signature">
    <template v-slot:headerRight>
      <b-btn variant="outline-info" @click="$router.back()">
        <i class="fas fa-arrow-left"/> {{ $t('sideBar.voltar') }}
      </b-btn>
    </template>
    <b-card class="m-3 mt-n10">
      <b-form @submit="onSubmit">
        <b-form-group :label="$t('tuevs.scale.form.fields.codigo.label')" label-for="input-codigo">
          <b-form-input id="input-codigo" v-model="scale.code" type="text"/>
        </b-form-group>
        <b-form-group :label="$t('tuevs.scale.form.fields.nome.label')" label-for="input-name">
          <b-form-input id="input-name" v-model="scale.name" type="text"/>
        </b-form-group>

        <b-form-group
            :label="$t('tuevs.scale.form.fields.status.label')"
            label-for="input-status"
            :description="$t('tuevs.scale.form.fields.status.description')"
        >
          <b-form-checkbox id="input-status" v-model="scale.status" size="lg" switch/>
        </b-form-group>
        <b-button type="submit" variant="success">
          <i class="fas fa-save"/> {{ $t('tuevs.scale.form.fields.botao_salvar') }}
        </b-button>
      </b-form>
    </b-card>
  </LayoutGradient>
</template>

<script>
import LayoutGradient from "@/templates/LayoutGradient";
import ScaleRepository from '@/repositories/tuevs/ScaleRepository'
import {mapActions, mapGetters} from "vuex";

export default {
  name: "Form",
  components: {
    LayoutGradient
  },
  computed: {
    ...mapGetters({
      scale: 'tuevs/scale/current',
      isLoading: 'tuevs/scale/isLoading'
    }),
    pageTitle() {
      if (this.scale_id) return this.$t('tuevs.scale.form.titulo_pagina.editar')
      return this.$t('tuevs.scale.form.titulo_pagina.criar')
    }
  },
  data() {
    return {
      scale_id: null
    }
  },
  methods: {
    ...mapActions([
      'tuevs/scale/listOne'
    ]),
    async onSubmit(evt) {
      evt.preventDefault()
      if (this.$route.params.id) {
        this.update()
      } else {
        this.create()
      }
    },
    create() {
      ScaleRepository.post(this.scale).then(() => {
        this.$snotify.success(this.$t('tuevs.scale.form.create.success'))
        this.$router.push({name: 'tuevs.scale'})
      }).catch(error => {
        this.$snotify.error(this.$t('tuevs.scale.form.create.error'))
        if (error.response.status === 422) {
          ScaleRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    },
    update() {
      ScaleRepository.put(this.scale_id, this.scale).then(() => {
        this.$snotify.success(this.$t('tuevs.scale.form.update.success'))
        this.$router.push({name: 'tuevs.scale'})
      }).catch(error => {
        this.$snotify.error(this.$t('tuevs.scale.form.update.error'))
        if (error.response.status === 422) {
          ScaleRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    }
  },
  async mounted() {
    this.$store.commit('tuevs/scale/setCurrent', {status: false})
    if (this.$route.params.id) {
      this.scale_id = this.$route.params.id
      await this['tuevs/scale/listOne'](this.$route.params.id)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
